export default "__VITE_ASSET__O5EiQJu2__"